export const PIPELINE_NAMES = [
"FCOpaquePublishing",
"FCCapacityConfigurationService",
"RodeoCattleprodService",
"SSPOTCorpProxy",
"RodeoEpicKinesisConsumer",
"InboundRodeoFrontendService",
"RodeoTodWorker",
"LaPIGService-Beta",
"FCCollatingHerdInstructions",
"FCAssociateNotificationService",
"AlpsBasecampContentBeta",
"AFTFreshExpiryDateAuditPortalWebApp",
"FCLearningWebsite",
"LPCXMemcached",
"FCCollateUI",
"FCCapoSDETools",
"DQCScripts",
"AFTFreshExpiryDateAuditService",
"AlpsReportingService-Beta",
"FCLMTrainingService",
"FCCAPO_NoOp",
"MoraineService",
"FCCollatingDemandDataService",
"AFTInAppTrainingService",
"ElasticSearchProxyWeb-IQS-release",
"FCCollatingWorkflowSIL",
"FCWorkSelectionService",
"FCWorkAssociateService",
"AFTFreshDailyQualityCheckService",
"TodWorker-IQS-Prod",
"TimberFS-IQS-release",
"FCHACOptimizationService",
"FANSJavaWebsite",
"FCWorkExecutionDashboard",
"AFTIQSScripts",
"FCChewieService",
"FCWorkExecutionQueueWorkers",
"AFTFreshExpiryDateAuditScannerPortal",
"FCWorkPlatform",
"AlpsReportingService",
"FCCountScannerTools",
"AFTFreshDailyQualityCheckScannerPortal",
"FCEwokService",
"FCJediService",
"FCAssociateEmploymentProfileService",
"ALPSService",
"AlpsBasecampContent",
"MoraineService-beta",
"FCIRDRService",
"FCCollatePlannerService",
"FCWorkTimePredictionService",
"LaPIGService",
"OFPPigs",
"FCWorkExecutionDashboard-aftx",
"AFTFreshDailyQualityCheckPortal",
"AFTUmbrellaLuminosCorpProxy",
"HrisFclmInterfaceWorker",
"UmbrellaContentNginxProxy",
"FCAssociateEmploymentProfileServiceUtilities-release",
"FCCollatingService",
"FCLMTrainingServiceTodWorker-TodWorker",
"FCTieService",
"ALPS",
"FCForceService",
"FCKPOWorkCleanUpService",
"FCSmrfService",
"FCDemandSwappingService-evaluator",
"FCDemandForecaster",
"AFTWatsonService",
"FCFlowPlanDebugWebsite",
"FCDemandForecasterSimulationService-experimental",
"FaaSTItemAllocationService",
"AFTPrepCertificationWebsite",
"EFPSkuMasterService",
"FCBindingService",
"FCLMPepsiService",
"AFTPrepInstructionsManager",
"EulerSlicer-Simulation",
"FCOutboundFlowDashboard-cascadecontrol",
"FaaSTConfigurationBridge",
"FCFlowPlanEvaluationAndAlarmingService",
"AFTQualityToolsWebsite",
"EulerFallbackPlanner",
"AftIbrBuildPalletWebUI",
"SkynetTimberFSQuiltNoOp",
"Boas",
"FaaSTInsightsDataServiceGlobal",
"FaaSTInventoryReplenishmentEventConsumer",
"AFTRestfulImageService",
"AFTPrepDataService",
"FCOutboundModelService",
"FCLMCAPService",
"FCDemandSwappingService-darkstack",
"FCLMLaborReportingService",
"AFTPrepPredictionInputEngine",
"AFTQualityToolsService",
"Cats",
"AFTPrepService",
"LaplaceDaemon",
"FCLMLaborMetricsAggregator",
"LPTFaaSTIntegTestsWithAAA",
"FCInventoryWorkflowService",
"SkynetCapacityModel",
"EulerSlicer",
"FlexWebsite",
"AFTZebraPrintService",
"LagrangeModelService",
"AFTQTTransferCloudwatchToPMETConfig-release",
"FCSkynetWebsite",
"AftLabelUnlabeledCaseWebsite",
"DynamicDynamoDBManager",
"EulerLoadTestDataGeneratorService",
"EulerFallbackPlanner-Simulation",
"AFTMycroftService",
"AFTPSAutomationTimberFSDummy-development",
"AFTRecordPrepWebsiteContent",
"FCFlowPlanDebugWebsite-Simulation",
"EulerCanary-Simulation",
"OFPSeals",
"FCDemandForecasterSimulationService",
"AFTFastAndFuriousService",
"FCPickingProcessPathService",
"OutboundFulfillmentModel",
"OutboundFulfillmentPlanner",
"LagrangeDashboard",
"FaaSTPointOfSaleShipmentServerless",
"FCSpaceManIDRTWebsite",
"InboundManifestProcessor-development",
"OutboundWorkflowLogic",
"TimberFS-LaborTracking",
"AftIbrBuildPalletService",
"FlowPlanExecution",
"AFTPoirotWebsite",
"FCDemandForecasterService-datadumper",
"Hermes",
"FCLaborCapacity",
"CatUI",
"AFTAgingInventoryWebsite",
"AFTProblemSolveAutomationScript",
"OFPHerdGraphDeployment",
"IVASPortal",
"TransshipCasePalletWebsite-development-ddb",
"FCInboundWarehouseConstraintService",
"OFPCrabs",
"AFTPSAutomationTransferCloudwatchToPMET-release",
"AFTPrepTransferCloudwatchToPMETConfig",
"FCLMLaborProcessingService",
"FCBulkRebindingService",
"AFTOEAutomator-dev",
"FCSpacemanIDRTService",
"FaaSTInsightsSnapshotConsumer-development",
"LagrangeModelService-simulation",
"FCLMJobEntryDomainInformationService",
"FCFlowPlanning",
"EulerPlanner-Simulation",
"FaaSTInboundDockCheckService",
"FCInventoryWorkflowPortal",
"FCOutboundFlowDashboardDataRecorderService",
"AFTSherlockApp-FCResearch",
"LaplaceDaemon-Simulation",
"LampsLaborTrackingInformationService",
"FCUnwindDemandService",
"FCInboundRoutingControlPlaneService",
"FaaSTInsightsKinesisAdapter",
"AFTInboundValueAddedService",
"FCInboundRoutingService",
"LaborTrackingWAGService",
"FCAsinProfiling",
"FCLMJobSchedulerService",
"EulerCanary",
"OutboundFlowFCDetector",
"FulfillmentRequestExecutionTrackingService",
"FCLMTodWorker",
"EFPFlexTools-dev",
"AustinEhsWebTestsCorpProxy",
"LagrangeDashboard-simulation",
"FCDemandSwappingService-recorder",
"RedbeardService",
"FCPickCompleteService",
"TransshipmentForecastServiceOctane",
"Pythia",
"MustangPortal",
"AFTWatsonSQSListenerService",
"FaaSTInsightsDataService",
"FCSpaceManDPSVerificationToolWebsite",
"FCProductionPlanner",
"AFTRiskDataGluePySpark-development",
"AFTMoriartyService",
"FCSpaceManPalletStowRecommendation",
"FCLMPortal",
"AFTPrepDecisionTreeService",
"EFPWarehouseManagementService",
"AFTAdjustReceiveService",
"FCLMCSIMiamiService",
"FCInboundRoutingMemcacheD",
"FCSpaceManPalletStowRecommendationWebsite",
"MustangService",
"AFTOutboundFlowTodWorker-development",
"AFTEmployeeLocationService",
"LampsTrackingAggregationService",
"OeAutomatorDashboard",
"FaaSTInsights-development",
"FCOutboundFlowMetricsDeck",
"AFTAgingInventoryService",
"AFTProblemSolveWebsite",
"FCOutboundLaborService",
"EulerPlanner",
"AFTUnicornPrintService",
"FCLMLEAVService",
"FCSpaceManAsinProfilingService",
"FCStowService",
"AFTYesDeCanService",
"FCPickingToolService-development",
"FCPackXslFoRenderingService",
"FCDecantInventoryPredictor",
"FUDReportsWebsiteContent",
"TaskUIInternalGateway-Ultraviolet345",
"ProactiveOutboundProblemSolve-FeatureDevelopment",
"FCInsightsCTOCE",
"FCStowAutomationService",
"Rosemary",
"ProactiveOutboundProblemSolveWebapp",
"AFTAtLisApp",
"TaskUIInternalGateway",
"LaborPlanGeneration",
"FCStowRecommendationService",
"LaborSchedulingJobsService",
"FCLaborScheduleService",
"AFTCartonFingerprintService",
"AFTPostPIDProcessingApp",
"AFT-Analytics-Env",
"TimberFS-FCStow-development",
"AFTPickApp-development",
"FCPickingToolWebsite",
"AFTBucketsworth",
"FCPortalHitch",
"WaterSpiderTool",
"FCStowSortationService",
"FCPickingDispatcherService-V2",
"FCStowAppWebsite",
"FCTaskActionNotificationService",
"InboundProcessPathPredictionService",
"AFTInboundDirectorService",
"SCLaborPlanExecution-beta",
"FCStowAppWebsiteContent-pilot",
"LaborSchedulingRosterService",
"LaborPlanExecutionBeta",
"AFTFreshInboundPrioritizationService",
"AFTInboundCTOListener",
"PrintDocumentFlow-FeatureDev",
"FCPSlipUIWebsite-development",
"FCStowBinRecommendationService-pilot",
"AutomatedETLRecoveryInboundDW",
"LaborSchedulingReportingService",
"LaborSchedulingUtilitiesService",
"FCInboundCheckInService",
"AFTWaterSpiderService",
"FCInboundInsights",
"FCStowWorkerService",
"MyTimeWrapper",
"AFTCartonArchiveService",
"LaborPlanExecution",
"FCPickingSchoolConsoleWebsite",
"AFTCartonTimelineApp",
"FCStowBinRecommendationService",
"AFTSenescenceService",
"AFTConManPortal",
"CatfeederSqsListener",
"AFTVisionTunnelProperties",
"AFTBiPythonUtilities-1-0-prod",
"AFTPalletCheckInApp",
"FCAppInsightProcessor",
"LaborPlanHerdInstruction",
"TimberFS-lampsopt-development",
"AFTInboundCTOService",
"AFTMoveApp",
"AFTCartonPrEditorApp",
"AFTQ4ReadinessDataService",
"Sitara-CAPPM",
"AFTFreshInboundPrioritizationDashboard",
"FUDService",
"FCPSlipUI",
"FCPackXslFoRenderingService-feature-dev",
"AFTPickApp",
"SCLaborPlanExecution",
"LaborSchedulingDistributedCacheService",
"FCPickingToolWebsite-development",
"FCInboundBufferTrackingCronJobs",
"SDPTicketD-development",
"DAPService",
"FCTaskActionNotificationListener",
"FCStowDataService",
"FCStowToteAsBinAppScripts",
"AFTVisionTunnelDisplayService",
"ProactiveOutboundProblemSolveWebapp-FeatureDevelopment",
"AFTInboundAutoCheckInService",
"PrintDocumentFlow",
"AFTCartonDataService",
"AFTVisionTunnelDisplay",
"FCHitchReportService",
"LaborPlanGenerationBeta",
"FCDecantDataService",
"FUDReports",
"ProactiveOutboundProblemSolve",
"AFTRosebudService",
"AFTPsychicService",
"AFTFreightLabelPrinterApp",
"AFTQ4ReadinessWebsite",
"AFTWhatsOnService",
"OutboundDefectAnalysisEngine",
"AFTMAWSProxyService",
"FCPickingToolService",
"CarnavalDoctor-release",
"FCStowPortal",
"FCPickingDispatcherServiceTools",
"AFTPalletPrEditorApp",
"FCInboundTrackingWebsite",
"FCInboundBufferTrackingService",
"FCStowService-pilot",
"EUEFFexDataConsumer",
"InboundProcessPathPredictionMemcached-development",
"FCGlobalPlanningService",
"FCEligibilityService",
"FCDBTools",
"FCPickSchedulerNoOp-mainline",
"VBIWarehouseInfrastructure",
"TransferCloudwatchToPMETVBI",
"LaborSchedulingSchedulePreferenceService",
"FCJobManagerService",
"FCDeathStarService",
"FCPickingCarouselService",
"VBICompute-bin-extraction",
"ShiftChoiceService",
"LaborSchedulingShiftBuilderService",
"VBIOperationsConsoleSSHKeyDJS-mainline",
"VBIG2S2ProxyService",
"VBICompute-auto-count",
"VBIMetadataCollector",
"LossPreventionService",
"SqsRemoteMessageConsumer",
"VBIOperationsConsole",
"FCDBRollingWebsite",
"FCPickingCodaService",
"VBIEdgeAlarms",
"FCPickingAnalyzerService",
"FCJobManagerWebsite",
"AFTCVBinInfoConsole",
"FCEligibilityWebsite-v2",
"FlexibleAssociateSchedulingWebsiteContent",
"LightSaber",
"NeverAgainAlarm",
"OFPDragons",
"ShipmentIssueAggregator",
"AFTSPEEDDating",
"FCMagicInductService",
"FCPickItemCreationService",
"UnreceiveWorkflow",
"QIReportingIngestionService",
"AFTPutToLightAdapter",
"AFTFreshCache",
"AIMRegionalTodWorker-dev",
"AFTSDETools",
"RebinBatchService",
"EFPShipmentMessageConsumer",
"TCABS",
"TransferEXecutionDataService",
"FCQualityWebsite-preview",
"SideLaunchService",
"BatchBufferTrackingService",
"AFTXInventoryHandoffWebappService",
"AIMMetadataService",
"TransshipmentCleanupService",
"FCPackageServiceDataWarehouseEDX",
"EFPMessageForwarding",
"TransshipmentDataService",
"AIMCloudFlash",
"AIMDatabaseService",
"EFMetricsPublisher",
"FCSocketService-Sortation",
"FCTransshipmentSortToolWebUI-SFC",
"BatchToteService",
"AIMCloudZooKeeper",
"FCTravelTimeMapBuilderService",
"MaterialFlowRainbowRoad",
"FCTransshipmentAggregator",
"TransshipmentContainerLabelGenerator",
"TransshipmentRequestService",
"AIMCloudIndexWriter",
"ItemSortationService",
"AFTPonyExpressService-mainline",
"PickingNexusService",
"DEV-DSK-ROTHWELL",
"AIMCloudMonitorServiceV2",
"FCTravelTimeService",
"FCQualityIANotificationListener",
"QI-FireStation",
"FCPickDemandService",
"FCConfigurationServiceCacheOut",
"QI-Reporting-Federation",
"EFNodeManagementService",
"RebinConfigurationService",
"Longdog-EFPMPortal",
"FCTaktzeitConfigurationService",
"S3LogIndexer-mainline",
"FCShipSocketServiceAIMSQSAgent",
"ToteRoutingApp",
"FCInboundTransshipmentAdhocTools-development",
"AmazonSortationScheduledJobs",
"FCContainerRoutingService-memcached",
"AIMAccessStreamIngest",
"FlowRebinService",
"TransshipmentReceiveTool",
"FCActualInboundShipmentService",
"FCTransshipmentDataWarehouse-live-ec2",
"AFTConManService",
"ContainerBuildServerQIDirectedCount-release",
"FCReceiveWebUIWebsite",
"FCBatchToteControllerService",
"FCTransshipmentBindHierarchyTool",
"EFPShipmentService",
"FCContainerRoutingService-v2",
"EFCore",
"FCInboundProblemReceiveService",
"FCPickEventRecordingService",
"FCPickReservationService",
"FCLocationServiceCacheOutDaemon",
"AFTTransshipmentMergeTool",
"AFTTransshipmentHubDashboard",
"AFTFreshChillChainReceive",
"FCSortationRatesReportService",
"FCQLargeAdjustmentNotificationProducer",
"AFTFreshCrossDockService",
"FulfillmentHistoryService",
"RebinUI",
"AFETrayControllerService",
"FlowRebinServiceMemcache",
"InductToteControllerService",
"TransferEXecutionAnalyticService",
"AFTPonyExpressWebsite",
"ARPodTransferDataService",
"EFPCustomerReturnService",
"FCQualityWebsite",
"AFTXInventoryMigrationService-mainline",
"AFTDockTruckWorkflow",
"FCPackageListener",
"SideLaunchWebsite",
"AFTShipConfigurationServiceCanary",
"FCConfigurationService",
"AFTLocationConfigurationWebsite",
"FCInboundTransshipmentService",
"WarehouseControlService-CORP",
"FlowInductApp",
"AIMDogeCloud2",
"FCQualityService",
"FlowSortationEventService",
"AFTSlamStationConfigService",
"QualityIntelligenceCountDataPipeline",
"Hero",
"TimberFS-FC-AIM",
"AFTShipTransferCloudwatchToPMET-mainline",
"FCShipSocketService",
"UnreceiveWebsite",
"FlowSortationDashboard",
"FCAutoDeploymentService",
"AFTFreshCrossDockPortal",
"FlowRebinWorker",
"AIMCloudLoadService",
"SideLaunchWorker",
"FCTransshipmentSortToolWebUI",
"SortTransshipItems",
"TEXDStoTEXASLambda-release",
"FCSortationTransshipService",
"FCLocationService",
"EFPTransferService",
"FCSortationConfigurationService",
"FCAutoSlamClientService-development",
"FCPackageService",
"ArsenalPortal",
"FlowRebinServiceMigration",
"FCReceiveMemcached-live",
"TransshipmentEventService-release",
"AFTTransshipmentManifestService",
"AFEContainerAssignerService",
"EFPQuiltNoOp",
"FCConfigurationServiceWebsite",
"TransshipQATool",
"AIMGateway",
"FCITSCacheOut-release",
"INSListenerIDAPT",
"FCInboundVendorManagementService",
"TransferRequestPortal",
"TransshipmentDataWarehouseEDX-development",
"AIMCloudIngestionService",
"BadgerWorkflowEngine-backtesting",
"AFTShipConfigurationService",
"WarehouseControlMonitoringService",
"SortationPortalWebsite",
"FCContainerRoutingService",
"QI-Reporting-Cluster",
"EFPMessagePlatform",
"FCSlam2Service",
"InventoryCostService",
"SideLaunchPoller",
"PickingNexusCache",
"ARPodTransferService",
"BadgerWorkflowEngine",
"FCInboundTransshipmentPortal",
"EFPInventoryMessageConsumer",
"TexdsExternalSqsLambdaApplication-development",
"AFTTransshipContainerService",
"FCInboundReceiveService",
"AIMCloudRetrService",
"AIMTPSGeneratorCanary",
"AIMDogeCloud",
"FCMapDataService",
"EFPSnapshotPublisher",
"ToteWrangleApp",
"LaunchTestService",
"FCPickItemLocationServiceSDETools",
"FCInventoryLevelSweeper",
"Snowbird",
"Eri",
"FCInventoryItemSnapshotProducer",
"EFPIncomingMessageConsumer",
"LetheControlPlane",
"ErgoEventService",
"IACMessageConsumer",
"LaborSchedulingAdminWebsiteContent",
"FaaSTPOEventProcessorService",
"GuidedCoachingEventService",
"EriCanary",
"FCSMScheduler",
"GuidedCoaching",
"FCInventoryWorkAssigner",
"TockmanService",
"PILSDoctor",
"ExternalTroubleTicketService",
"SNOWWorkflowDashboard",
"InventoryEventProcessor-development-sqs",
"FCInventoryAdjustmentNotificationProducer",
"LaborSchedulingOpportunitiesService",
"TockmanCoral",
"EFRemovalOrderService",
"FCInventoryItemSnapshotConsumer",
"SNOWPlatform",
"EFProblemReceiveService",
"ZirnitraTodWorker-DISABLED",
"SNOWWorkflow",
"LaborSchedulingAssociateWebsiteContent",
"FCLaunchRequirement",
"OatsDatabaseTools",
"AFPTransshipmentRestService",
"FCInventoryCostSweeper",
"AFPTransshipmentConsumer",
"FCInventorySyncSchedulerService",
"FCPickItemLocationService",
"FCInventoryItemServiceCoralThrottlingConfigurationUploader",
"LetheMessageBusSweeperService",
"SNOWController",
"GuidedCoachingProcessorService",
"GuidedCoachingWebsite",
"Regional-LCP",
"FCInventoryInternalToolsJava",
"FCInboundDockService-postgres",
"RiverSQSConsumers",
"RiverUI",
"FCSpaceManInventoryStorageWorkflow",
"TimberFS-pack-development",
"SDPTodWorker-release",
"FCSkuMasterAsinFilterWorkers",
"LaPMIService",
"FaaSTAuthorizationServerless",
"FCEventTrackingService",
"FCExpectedInboundShipmentService-postgres",
"FCTRExWorkflows",
"FCSkuMasterServiceCoral",
"AFTPackConfigurationWebsite",
"FCSpaceManConsolidationService",
"FCSkuTroubleshooterService",
"FemidaWebsite",
"FemidaToolsService",
"AFTINGExplorerWebsite",
"AFTReplenDataCollector",
"PackAppWebsiteService",
"AFTReplenPDSNetworkForecastCollector",
"FCShipmentDataService",
"Femida-Reporting-Cluster",
"SRS-TransformEngine",
"FCInboundDockmasterWebsite",
"FCFulfillmentRequestProcessingService",
"TunnelPlatformWebsiteContent-mainline",
"SRS-Tools",
"FCSkuMasterMAWSCanary",
"FRPSThrottlingConfigurationUploader",
"FaaSTRosterServerless",
"RiverIssueService",
"FCSpaceManConsoleDWToS3Pipes",
"AFTGaussService",
"FCSkuMasterINSListener",
"FemidaReportingIngestionService",
"FemidaService",
"FemidaEventService",
"SRS-Forwarder",
"RiverExternalWebsite-development",
"SRS-LoggingSystem",
"AFTReplenishmentPlanner",
"RiverNotificationService",
"AFTCVTunnelSystemPID-mainline",
"LAPINService",
"FCInboundDockHub-release",
"AFTINGZeusPopulator-release",
"FCSpaceManFnskuVelocityService",
"FCInboundDockWorkFlowService",
"Space3RCQuiltNoOp-development",
"AFTINGZeusQueryService-release",
"RiverExecutionService",
"RiverAccessControlService",
"LaborPlanConfigurationService",
"AlpsAvalancheService",
"FCSPSSocketService-release",
"RiverUtilities",
"FulfillmentDomainMemcachedLauncher-dev",
"SRS-Scheduled-Batch-Processes",
"RiverTicketWatcherService",
"FaaSTInvitationServerless",
"SimplePackToolWebsite",
"ReLappService",
"FCSkuMasterCacheOut",
"FCSkuMasterUpstreamPublisher",
"FCMenuWebsite",
"FCSpaceManConsolidationTools-dev",
"FCSpaceManPredictiveDemandSystem",
"RiverService",
"FulfillmentDomainQueueWorkers",
"FCSpaceManContainerStorageWorkflow",
"FemidaToolsWebsite",
"SSOFaaSTWebsite",
"FCShipmentMessageConsumer",
"SkuMasterCacheBuster",
"SkuMasterMultiboxWebsite",
"FCInboundDockExecutionService",
"SRS-Mock-Observer",
"SimpleReactiveService",
"FCSkuMasterService-shadow",
"SDPDynamoDBManager",
"AFTReplenishmentScheduler",
"SDPTransferCloudwatchToPMETConfig",
"FCReceivePOService",
"AFTINGBatcher-release",
"RiverWFSSWebsite",
"ElasticSearchProxyWeb-FaaST-development",
"SimplePackService",
"MenuItemSelfServicePortal",
"AFTXToolsMenuWebsiteService",
"StorageCostRecommender",
"RiverWorkflowMetadataService",
"FFRMTroubleshootingWebsite",
"LampsOptModellingTools",
"FemidaReportingMaintenanceJobsScheduler",
"SpacemanDatawarehouseS3Pipes-development",
"FCSalesAggregator",
"FCLMSITHService",
"AFN-GlobalShipmentAuthority-Release",
"FCSpaceManConsolidationWebsite",
"FCSpaceManForecastDataPipe",
"FemidaDocumentService",
"FCSkuMasterScripts",
"FaaSTUserServerless",
"FCShipmentSnapshot",
"ReplenishmentExplorer",
"FCLMEmployeeSettingsService",
"FulfillmentDomainQueueWorkersCacheOut",
"HourWebsiteRb",
"AlpsAvalancheService-Beta",
"FCSpaceManReplenishmentService",
"LampsSPADEService",
"InboundPlatformDWFeeds-release",
"FCSkuTroubleshooterWebsite",
"AFTINGEventStoreService-release",
"FemidaProcessorService",
"SDPDynamoDBToElasticSearch-release",
"FCMaterialIngestionScripts-dev",
"LaPMIService-beta",
"SkuMasterMultiboxService",
"Femida-Reporting-Federation",
"FCShipmentDataServiceTools",
"ShippingReportsUpdaterService",
"AFTInboundFlowControlWebsite",
"AFTMACService",
"AFTEmployeeLocationServiceImporter",
"FCDashboardWebsite",
"RodeoItemFlowLedger",
"AFTFreshScripts",
"FCShiftExecutionReportService",
"AFTInboundFlowControlImporter",
"FCShiftPerformanceReportEventEvaluator",
"FCLaborScheduleWebsite",
"FCBinDataService",
"IDQTroubleshooter-aftx",
"FCLaborExecutionAndOptimizationService",
"AFTInboundFlowControlTimberFS",
"FindAndFixService",
"SlamOpsWebsite",
"AFTIDQDJSAgent",
"FCInboundWorkOrderService",
"AFTATACUserInterface",
"LaborSchedulingScheduleAuthorityWebsite",
"AFTIDQMadman-development",
"AFTFreshTransformationService",
"AFTItemMadCatWebsite",
"SCDBE-WEB-NODEJS-release",
"FCSpacemanS3SnapshotProducers",
"AFTFreshReportsService",
"AFTIFCHistoricalDataService",
"AFTFreshReportsWebsite",
"AFTFreshAsinTransformationReport",
"FCStowMapWebsite",
"FCShipWebApplicationToolsWebsite-betaMenu",
"FCInboundInfrastructureService",
"RodeoFrontendService",
"RodeoEventProcessingServiceMemcache",
"RodeoRANCH",
"GoreyService",
"SummarizeMyDataService",
"RodeoElasticSearchService",
"RodeoDJSRubyScripts",
"SCOTDEDataRelease",
"InboundRodeoEventProcessingService",
"RodeoAggregationForFlowLedger",
"RodeoWebsite",
"FCOutboundFlowDashboard-SERA",
"FCInboundCapacityDataCollector",
"AFTInboundFlowControlService",
"FCOpaqueDJSRubyScripts",
"LaborSchedulingSiteSchedulesService",
"AFTIBShipmentVisibilityService",
"AFTEEAvailabilityDashboard-release",
"RodeoTimberFS",
"ItemIntelligenceWebsite",
"FCCapacityConfigurationWebsite",
"AFTItemMeasurementAction",
"FCSpaceManBinInformationService",
"RodeoEventProcessingService",
"FCShipWebApplicationToolsWebsite",
"FCLaborExecutionAndOptimizationMetricsDeck",
"CAAMDataForager",
"StaffingCommandCenterWebsite",
"FCScaleAccuracyService",
"AFTFreshTransformationsAvailabilityService",
"FCSpaceManAdhocTools",
"FCBayValidationToolWebsite",
"FCAsinTransformationGenerator",
"MurfiService",
"LaborSchedulingAssociateSchedulesService",
"AFTATTunnelDataRouter-development",
"AFTInboundWorkImporter",
"FCBinManagementService",
"AFTFreshTransformationWebsite",
"FCDashboardService",
"FCDefectDetectionService",
"FCBaySnapShotProducer",
"CocaTarget1CoralServiceTest",
"CocaTarget2CoralServiceTest",
"CocaUpstreamCoralServiceTest",
"CocaDownstreamCoralServiceTest",
"XuanshOctaneCliCoralServiceTest",
"Other"
]